<ng-container *ngIf="tableModel">
	<div class="p-grid">
		<div class="p-col-12">
			<span class="p-float-label mt-4">
				<input pInputText #modelNameInput name="modelNameInput" type="text" [(ngModel)]="tableModel.name" class="w-100" />
				<label for="modelNameInput">Table Model Name</label>
			</span>
		</div>
	</div>
	<div class="d-flex flex-column">
		<ng-container *ngFor="let column of tableModel.columns">
			<p-divider
				><div class="display-8">{{ column.displayName }}</div></p-divider
			>
			<div class="w-100 d-flex">
				<span class="p-float-label mt-4 flex-fill">
					<input pInputText #columnDisplayNameInput name="columnDisplayNameInput" type="text" [(ngModel)]="column.displayName" class="w-100" />
					<label for="columnDisplayNameInput">Display Name</label>
				</span>
				<span class="p-float-label mt-4 flex-fill">
					<input pInputText #columnSortPropertyInput name="columnSortPropertyInput" type="text" [(ngModel)]="column.sortProperty" class="w-100" />
					<label for="columnSortPropertyInput">Sort Value</label>
				</span>
				<p-checkbox
					styleClass="mt-auto ms-4"
					labelStyleClass="mt-auto"
					name="columnDisplayInput"
					binary="true"
					[(ngModel)]="column.display"
					label="Display by default"
				></p-checkbox>
			</div>
			<div class="w-100 d-flex">
				<span class="p-float-label mt-4 flex-fill">
					<input pInputText #columnDataValueInput name="columnDataValueInput" type="text" [(ngModel)]="column.dataProperty" class="w-100" />
					<label for="columnDataValueInput">Data Property</label>
				</span>
				<p-checkbox
					styleClass="mt-auto ms-4"
					labelStyleClass="mt-auto"
					name="columnDataIsArray"
					binary="true"
					[(ngModel)]="column.dataObjectArray"
					label="Column contents is in an array"
				></p-checkbox>
			</div>
		</ng-container>
	</div>
</ng-container>
<ng-container *ngIf="!tableModel">
	<div class="d-flex w-100">
		<div class="mx-auto display-8">Select Table Model</div>
	</div>
</ng-container>
